// import { Button, Icon, Theme } from '@prometheus/components';
import React, { FC } from 'react';
import { useNavigate, useLocation, Link, NavLink } from 'react-router-dom';
import {
  StyledButton,
  NavigationContainer,
  LogoContainer,
} from './SideNavigation.styles';
import {
  Box,
  IconName,
  MainMenuIcon,
  Tooltip,
  Typography,
} from '@prometheus/components';
import { Logo } from '../Logo/Logo';
import { BuildInfo } from '../BuildInfo/BuildInfo';

export const SideNavigation: FC<any> = props => {
  const { list } = props;
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = React.useCallback(
    (path?: string) => location.pathname.split('/')[1] == path,
    [location]
  );
  return (
    <NavigationContainer>
      <LogoContainer to="/">
        <Logo />
      </LogoContainer>

      {list?.map((item: any) => (
        <Tooltip placement="right" text={item.title || ''} key={item.name} show>
          <div>
            <StyledButton
              to={item.path || ''}
              // onClick={() => navigate(item.path || '')}
              // variant="text"
              // disableRipple
            >
              <Box
                className="icon-wrapper"
                sx={theme => ({
                  padding: 1,
                  borderRadius: 1,
                  ...(isActive(item.path)
                    ? {
                        backgroundColor: theme.palette.backgroundColor.main,
                      }
                    : {}),
                })}
              >
                <MainMenuIcon iconName={item.iconName as IconName} />
              </Box>
              <Typography
                fontSize={10}
                sx={theme => ({
                  width: '100%',
                  color: theme.palette.primary.main,
                })}
                fontWeight="bold"
                // mt={0.5}
              >
                {item.title}
              </Typography>
            </StyledButton>
          </div>
        </Tooltip>
      ))}
      <BuildInfo />
    </NavigationContainer>
  );
};
